import { useContext } from "react";
import { Header } from "../../../components/Landing/Header/haeder.view";
import { BannerJurados } from "../components/BannerJurados";
import { Footer } from "../../../components/Landing/Footer";
import { TextoinicialNumero } from "../components/TextoinicialNumero";
import { Input, Button, Form, Table, Empty, Select, Popover } from "antd";
import { useAgregarExperienciaJurado } from "../../../hooks/useAgregarExperienciaJurado";
import { EyeOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { ModaleditarExperiencias } from "./ModalEditarExperiencia";
import { ModalEliminarExperiencia } from "./ModalEliminarExperiencia";
import { ModalVisualizarDocumentos } from "../../../components/Generales/ModalVisualizarDocumentos";
import moment from "moment";
import { openNotification } from "../../../utils/Notifactions";
import { TemplateContext } from "../../../utils/template_context";
import DocumentInput from "../../../utils/DocumentInput";
import { useNavigate } from "react-router-dom";
import { UseVerConvocatorias } from "../../../hooks/UseVerConvocatorias";

export const AgregarExperiencia = () => {
  const navigate = useNavigate();
  const {
    getConvocatoriaPersistente,
    convocatoriaPersitente: convocatoria,
    setConvocatoriaPersitente,
    descargarArchivo,
  } = UseVerConvocatorias();
  const {
    experiencia,
    setExperiencia,
    experiencias,
    setExperiencias,
    modaleditar,
    setModaleditar,
    modaleliminar,
    setModaleliminar,
    indexExperiencia,
    setIndexExperiencia,
    fileInputRef,
    agregarFila,
    limpiarCampos,
    guardarCamposModal,
    guardarArchivo,
    eliminarFila,
    nombreConvocatoria,
    setNombreConvocatoria,
    areas,
    setAreas,
    guardarExperienciaJurado,
    modalVisualizar,
    setModalVisualizar,
    prevScreen,
  } = useAgregarExperienciaJurado();

  const context = useContext(TemplateContext);
  // columnas tabla
  const columns: any = [
    {
      title: "No.",
      width: 60,
      render: (datos: any, datos2: any, index: number) => (
        <span>{index + 1}</span>
      ),
    },
    {
      title: "Nombre del proyecto o la convocatoria",
      width: 200,
      dataIndex: "nombre_convocatoria",
      key: "nombre_convocatoria",
      fixed: context.device === "md" ? "left" : false,
      render: (datos: any) => {
        return datos.length > 27 ? (
          <Popover content={datos} title="Nombre Convocatoria">
            {`${datos.substring(0, 27)}...`}
          </Popover>
        ) : (
          datos
        );
      },
    },
    {
      title: "Entidad",
      width: 100,
      dataIndex: "entidad",
      key: "entidad",
      render: (datos: any) => {
        return datos.length > 27 ? (
          <Popover content={datos} title="Nombre Entidad">
            {`${datos.substring(0, 27)}...`}
          </Popover>
        ) : (
          datos
        );
      },
    },
    {
      title: "Año",
      width: 100,
      dataIndex: "anio",
      key: "anio",
    },
    {
      title: "Ciudad",
      width: 100,
      dataIndex: "ciudad",
      key: "ciudad",
    },
    {
      title: "Area",
      width: 100,
      dataIndex: "area",
      key: "area",
    },
    {
      title: "Anexar documento",
      width: 100,
      dataIndex: "documento",
      key: "documento",
    },
    {
      title: (
        <div className="row">
          <div className="col-12 text-nowrap justify-content-center">
            Acciones
          </div>
          <div className="col-4 text-nowrap font-size-10px font-color-B0B0B0">
            Ver
          </div>
          <div className="col-4 text-nowrap font-size-10px font-color-B0B0B0">
            Editar
          </div>
          <div className="col-4 text-nowrap font-size-10px font-color-B0B0B0">
            Eliminar
          </div>
        </div>
      ),
      width: 100,
      render: (datos: any, datos2: any, index: number) => (
        <div className="row">
          <div className="col-4">
            <Button
              className="button-gray-ghost"
              onClick={() => {
                setExperiencia(datos);
                setIndexExperiencia(index);
                return setModalVisualizar(true);
              }}
              icon={<EyeOutlined />}
            ></Button>
          </div>
          <div className="col-4">
            <Button
              className="button-gray-ghost"
              onClick={() => {
                console.log(index);
                setExperiencia(datos);
                setIndexExperiencia(index);
                return setModaleditar(true);
              }}
              icon={<EditOutlined />}
            ></Button>
          </div>
          <div className="col-4">
            <Button
              className="button-gray-ghost"
              onClick={() => {
                setIndexExperiencia(index);
                setNombreConvocatoria(datos.nombre_convocatoria);
                return setModaleliminar(true);
              }}
              icon={<DeleteOutlined />}
            ></Button>
          </div>
        </div>
      ),
    },
  ];
  // form
  const fields = [
    { name: "index", value: experiencia.index },
    { name: "nombre_convocatoria", value: experiencia.nombre_convocatoria },
    { name: "entidad", value: experiencia.entidad },
    { name: "anio", value: experiencia.anio },
    { name: "ciudad", value: experiencia.ciudad },
    { name: "area", value: experiencia.area },
    { name: "documento", value: experiencia.documento },
  ];

  return (
    <div>
      <Header />
      <BannerJurados BannerText="Banco de Jurados - Mi experiencia como jurado" convocatorias={convocatoria}/>
      <div className="container-fluid2">
        <div className="row">
          <div
            style={{ fontSize: "18px", fontFamily: "Montserrat-Bold" }}
            className="mt-5"
          >
            Agrega tu experiencia en procesos de formulación, ejecución y evaluación de proyectos{" "}
            <span
              style={{ fontFamily: "Montserrat-Regular" }}
              className="font-size-16px"
            >
              {" "}
              (Este paso es opcional, si no cuentas con experiencia como jurado
              haz clic en el botón de continuar)
            </span>
          </div>
          <div className="col-12">
            <div className="row"></div>
          </div>
        </div>
      </div>

      <div className="container-fluid2">
        <div className="col-12 p-2">
          <div className="row">
            <TextoinicialNumero
              numero="6"
              textosinspan="Experiencia en procesos de formulación, ejecución y evaluación de proyectos"
              textospan="Si deseas llenar este formulario recuerda que todos los campos son obligatorios"
              color="morado"
            />
          </div>
        </div>
      </div>
      <Form
        size="large"
        name="basic"
        onFinish={(values: any) => {
          if (values.documento === "") {
            return openNotification({
              titulo: "Error",
              descripcion: "Falta adjuntar archivo",
              placement: "bottomRight",
            });
          }
          agregarFila();
        }}
        fields={fields}
        onFieldsChange={(_: any, fields: any) => {
          let infoupdate: any = { ...experiencia };
          if (_[0].name[0] === "anio") {
            return;
          }
          infoupdate[_[0].name[0]] = _[0].value;
          setExperiencia(infoupdate);
        }}
      >
        <div className="container-fluid2">
          <div className="row">
            <div className="col-12 col-md-6 col-lg-3 col-xxl-3 mt-4">
              <span className="width-100 font-family-Montserrat-SemiBold font-size-12px container-span-titulos-bottom">
                Nombre del proyecto o la convocatoria
              </span>
              <div>
                <div className="col-12">
                  <Form.Item
                    className="no-margin"
                    name="nombre_convocatoria"
                    rules={[{ required: true, message: "Campo obligatorio" }]}
                  >
                    <Input
                      onChange={(e) => {
                        e.target.value = e.target.value.replace(
                          /[^a-zA-Záéíóú ]+/g,
                          ""
                        );
                        setExperiencia({
                          ...experiencia,
                          nombre_convocatoria: e.target.value,
                        });
                      }}
                    />
                  </Form.Item>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-3 col-xxl-3 mt-4">
              <span className="width-100 font-family-Montserrat-SemiBold font-size-12px container-span-titulos-bottom">
                Entidad
              </span>
              <div>
                <div className="col-12">
                  <Form.Item
                    className="no-margin"
                    name="entidad"
                    rules={[{ required: true, message: "Campo obligatorio" }]}
                  >
                    <Input />
                  </Form.Item>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-3 col-xxl-3 mt-4">
              <span className="font-family-Montserrat-SemiBold font-size-12px container-span-titulos-bottom">
                Año
              </span>

              <Form.Item
                className="no-margin"
                name="anio"
                rules={[{ required: true, message: "Campo obligatorio" }]}
              >
                <Input
                  min={1950}
                  maxLength={4}
                  onChange={(e) => {
                    e.target.value = e.target.value.replace(/\D/, "");
                    console.log(
                      parseInt(e.target.value),
                      parseInt(moment().format("YYYY"))
                    );
                    if (
                      parseInt(e.target.value) >
                      parseInt(moment().format("YYYY"))
                    ) {
                      openNotification({
                        titulo: "Error",
                        descripcion: "La fecha digitada es mayor a la actual",
                        placement: "bottomRight",
                      });
                      return setExperiencia({
                        ...experiencia,
                        anio: e.target.value.substring(0, 3),
                      });
                    }
                    setExperiencia({ ...experiencia, anio: e.target.value });
                  }}
                />
              </Form.Item>
            </div>
            <div className="col-12 col-md-6 col-lg-3 col-xxl-3 mt-4">
              <span className="width-100 font-family-Montserrat-SemiBold font-size-12px container-span-titulos-bottom">
                Ciudad
              </span>

              <Form.Item
                className="no-margin"
                name="ciudad"
                rules={[{ required: true, message: "Campo obligatorio" }]}
              >
                <Input
                  onChange={(e) => {
                    e.target.value = e.target.value.replace(
                      /[^a-zA-Záéíóú ]+/g,
                      ""
                    );
                    setExperiencia({ ...experiencia, ciudad: e.target.value });
                  }}
                />
              </Form.Item>
            </div>
            <div className="col-12 col-md-12 col-lg-6 col-xxl-6 mt-4">
              <span className="width-100 font-family-Montserrat-SemiBold font-size-12px container-span-titulos-bottom">
                Áreas
              </span>
              <div>
                <div className="col-12">
                  <Form.Item
                    className="no-margin"
                    name="area"
                    rules={[{ required: true, message: "Campo obligatorio" }]}
                  >
                    <Select style={{ width: "100%" }} placeholder="area">
                      {areas.map(({ id_area, nombre_area }) => (
                        <Select.Option key={id_area} value={nombre_area}>
                          {nombre_area}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-12 col-lg-6 col-xxl-6 mt-4">
              <span className="width-100 font-family-Montserrat-SemiBold font-size-12px container-span-titulos-bottom">
                Anexar documento
              </span>
              <div>
                <div className="col-12">
                  <Form.Item
                    className="no-margin"
                    name="documento"
                    rules={[
                      { required: true, message: "Documento obligatorio" },
                    ]}
                  >
                    <DocumentInput
                      doc={experiencia.documento}
                      fileInputRef={fileInputRef}
                      ancho_btn={30}
                      on_change={(e) => {
                        guardarArchivo(e);
                        e.target.value = "";
                      }}
                      onDelete={() => {
                        setExperiencia({
                          ...experiencia,
                          documento: "",
                        });
                      }}
                    />
                  </Form.Item>
                </div>
              </div>
            </div>
            <div className="col-12 justify-content-flex-end">
              <div>
                <div
                  className="col"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "end",
                  }}
                >
                  <Button
                    style={{ marginBottom: "20px" }}
                    className="button-azul-ghost font-size-12px"
                    onClick={limpiarCampos}
                  >
                    Limpiar campos
                  </Button>
                  <Button
                    className="button-blanco-radius font-size-12px"
                    htmlType="submit"
                  >
                    Agregar
                  </Button>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12">
            <div className="row-shadow-tablas">
              <Table
                pagination={false}
                dataSource={Array.isArray(experiencias) ? experiencias : []}
                columns={columns}
                locale={{
                  emptyText: (
                    <Empty
                      description="No se han diligenciados datos para está sección"
                      style={{ padding: "50px" }}
                    />
                  ),
                }}
                size="large"
                bordered={false}
              />
            </div>
          </div>
          <div
            className="row bg-white"
            style={{
              justifyContent: "center",
              marginTop: "0%",
              position: "sticky",
              bottom: 0,
              paddingBottom: "0%",
            }}
          >
            <div className="col  justify-content-flex-end">
              <Button style={{ marginRight: "1%" }} type="link" className="button-blanco-radius font-size-12px" onClick={() => { return navigate('/usuario/agregarExperienciaProfesionalJurado') }}>
                Atrás
              </Button>
              <Button
                className="button-azul-radius font-size-12px"
                onClick={guardarExperienciaJurado}
              >
                Continuar
              </Button>
            </div>
          </div>
        </div>
      </Form>
      <Footer />
      <ModaleditarExperiencias
        experiencia={experiencia}
        setExperiencia={setExperiencia}
        experiencias={experiencias}
        setExperiencias={setExperiencias}
        modal={modaleditar}
        setModal={setModaleditar}
        guardarCambios={guardarCamposModal}
        limpiarcampos={limpiarCampos}
        areas={areas}
        indexExperiencia={indexExperiencia}
        setAreas={setAreas}
      />
      <ModalEliminarExperiencia
        modal={modaleliminar}
        nombre={nombreConvocatoria}
        eliminar={() => eliminarFila(indexExperiencia)}
        indexExperiencia={indexExperiencia}
        cancelar={() => setModaleliminar(false)}
      />
      <ModalVisualizarDocumentos
        state={experiencia}
        visualizar={modalVisualizar}
        setVisualizar={setModalVisualizar}
      />
    </div>
  );
};
